var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datetime',{attrs:{"format":"YYYY-MM-DD H:i:s"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }